import React from 'react'
import DashSessionSection from '../../components/DashComponents/DashSessionSection'

function DashSessions() {
  return (
    <div>
      <DashSessionSection/>
    </div>
  )
}

export default DashSessions